// extracted by css-extract-rspack-plugin
export default {"Box":"issue-type-renderer-module__Box__ichqN","Token":"issue-type-renderer-module__Token__Iu1tQ"};